import React, { PureComponent } from "react";
import { connect } from "react-redux";

import { ThemeContext } from "~/utils";

interface StateProps {
  authenticatedUser: any;
}

interface DispatchProps {}

interface OwnProps {
  autoComplete?: string;
  className?: string;
  disabled?: boolean;
  id?: string;
  maxLength?: number;
  name?: string;
  onBlur?: any;
  onChange?: any;
  onClick?: any;
  onKeyPress?: any;
  onFocus?: any;
  placeholder?: string;
  required?: boolean;
  type?: string;
  value?: string;
}

type Props = StateProps & DispatchProps & OwnProps;

type State = {
  focus: boolean;
};

const mapStateToProps = (state: any) => ({
  authenticatedUser: state.users.authenticatedUser,
});

class ThemedInput extends PureComponent<Props, State> {
  state = {
    focus: false,
  };

  handleFocus = () => {
    this.setState({ focus: true }, () => {
      if (this.props.onFocus) this.props.onFocus();
    });
  };

  handleBlur = () => {
    this.setState({ focus: false }, () => {
      if (this.props.onBlur) this.props.onBlur();
    });
  };

  render() {
    let brandColor;
    const { authenticatedUser: user } = this.props;
    if (
      this.context.theme ||
      (user && user.company && user.company.whitelabeling)
    ) {
      const theme = this.context.theme;
      brandColor =
        theme === "default"
          ? user.company.whitelabeling.primary_css_color
          : theme;
    }
    return (
      <input
        autoComplete={this.props.autoComplete}
        className={this.props.className || "input"}
        disabled={this.props.disabled}
        id={this.props.id}
        maxLength={this.props.maxLength}
        name={this.props.name}
        onClick={this.props.onClick}
        onKeyPress={this.props.onKeyPress}
        onChange={this.props.onChange}
        onBlur={this.handleBlur}
        onFocus={this.handleFocus}
        placeholder={this.props.placeholder}
        required={this.props.required}
        style={
          brandColor && this.state.focus ? { borderColor: brandColor } : {}
        }
        type={this.props.type}
        value={this.props.value}
      />
    );
  }
}

ThemedInput.contextType = ThemeContext;

export default connect(mapStateToProps)(ThemedInput);
